import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable, from, of, switchMap, map } from 'rxjs';

import { CodeModalService } from '../code-modal.service';
import { ProofOfDeliveryCodeService } from '../proof-of-delivery-code.service';

@Injectable({ providedIn: 'root' })
export class ProofOfDeliveryCodeGuard implements CanActivate, CanMatch {
  constructor(
    private modal: CodeModalService,
    private codeSvc: ProofOfDeliveryCodeService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    // Try to read customerId directly; if this is the proof child route, fall back to the parent
    let customerId = route.paramMap.get('customerId') || '';
    if (!customerId && route.parent) {
      customerId = route.parent.paramMap.get('customerId') || '';
    }
    return this.validate(customerId);
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    // Always allow the route to match; actual customerId validation happens in canActivate
    return of(true);
  }

  private validate(customerId: string): Observable<boolean | UrlTree> {
    // 1) bind the correct customerId up-front
    this.codeSvc.setCustomerId(customerId);

    // If we already have a valid token, skip the modal
    if (this.codeSvc.token) {
      return of(true);
    }

    // 2) open your modal to get the code
    return from(this.modal.open()).pipe(
      switchMap(code => {
        if (!code) {
          // user cancelled
          return of(this.router.parseUrl('/access-denied'));
        }
        // 3) verify only with the code
        return this.codeSvc.verifyCode(code).pipe(
          map(ok => ok || this.router.parseUrl('/access-denied'))
        );
      })
    );
  }
}